
export const Category = [
        {
            "id": "0",
            "name": "All News",
            "image":"https://images.pexels.com/photos/242492/pexels-photo-242492.jpeg?auto=compress&cs=tinysrgb&w=600"
        },
        {
            "id": "1",
            "name": "Sports",
            "image":"https://images.pexels.com/photos/1618200/pexels-photo-1618200.jpeg?auto=compress&cs=tinysrgb&w=600"
        },
        {
            "id": "2",
            "name": "Technology",
            "image":"https://images.pexels.com/photos/1034812/pexels-photo-1034812.jpeg?auto=compress&cs=tinysrgb&w=600"
        },
        {
            "id": "3",
            "name": "Style",
            "image":"https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=600"
        },
        {
            "id": "4",
            "name": "Business",
            "image":"https://images.pexels.com/photos/3183197/pexels-photo-3183197.jpeg?auto=compress&cs=tinysrgb&w=600"
        },
        {
            "id": "5",
            "name": "Entertainment",
            "image":"https://images.pexels.com/photos/1190297/pexels-photo-1190297.jpeg?auto=compress&cs=tinysrgb&w=600"
        },
        {
            "id": "6",
            "name": "Parenting",
            "image":"https://images.pexels.com/photos/236164/pexels-photo-236164.jpeg?auto=compress&cs=tinysrgb&w=600"
        },
        {
            "id": "7",
            "name": "World News",
            "image":"https://images.pexels.com/photos/1078850/pexels-photo-1078850.jpeg?auto=compress&cs=tinysrgb&w=600"
        },
        {
            "id": "8",
            "name": "Arts",
            "image":"https://images.pexels.com/photos/2559741/pexels-photo-2559741.jpeg?auto=compress&cs=tinysrgb&w=600"
        }
]

export const News =[
            {
            "category":"1",
            "id":"1",
            "link":"https://www.huffpost.com/entry/dodgers-baseball-obit-wills_n_6329feb3e4b07198f0134500",
            "headline":"Maury Wills, Base-Stealing Shortstop For Dodgers, Dies At 89",
            "short_description":"Maury Wills, who helped the Los Angeles Dodgers win three World Series titles with his base-stealing prowess, has died.",
            "authors":"Beth Harris, AP",
        "date": "2022-09-20",
        "image": "https://img.huffingtonpost.com/asset/632a02732200005e00503b89.jpeg?ops=scalefit_720_noupscale&format=webp"
            },
            {
            "category":"1",
            "id":"2",
            "link":"https://www.huffpost.com/entry/2022-wnba-finals_n_6327f56fe4b0eac9f4e3144d",
            "headline":"Las Vegas Aces Win First WNBA Title, Chelsea Gray Named MVP",
            "short_description":"Las Vegas never had a professional sports champion — until Sunday.",
            "authors":"Pat Eaton-Robb, AP",
                "date": "2022-09-19",
                "image": "https://img.huffingtonpost.com/asset/6327f5c32300005b00981482.jpeg?cache=EfRPiKVhHS&ops=scalefit_720_noupscale&format=webp"
            },
            {
            "category":"1",
            "id":"3",
            "link":"https://www.huffpost.com/entry/boston-marathon-nonbinary-runners_n_631fade4e4b046aa0237a055",
            "headline":"Boston Marathon To Make Race More Inclusive For Nonbinary Runners",
            "short_description":"The race's organizers say nonbinary athletes won't have to register with the men's or women's divisions and provided qualifying times to guide their training.",
            "authors":"Sanjana Karanth",
            "date":"2022-09-12","image":"https://img.huffingtonpost.com/asset/631fb1c825000032001f5bfc.jpeg?cache=m3jMLdLsTC&ops=scalefit_720_noupscale&format=webp"
            },
            {
            "category":"1",
            "id":"4",
            "link":"https://www.huffpost.com/entry/anthony-varvaro-dead_n_631f6827e4b027aa405e1899",
            "headline":"Anthony Varvaro, MLB Pitcher Turned Transit Cop, Dies In Crash On Way To 9/11 Ceremony",
            "short_description":"Varvaro pitched mostly with the Atlanta Braves and started his law enforcement career in 2016.",
            "authors":null,
            "date":"2022-09-12","image":""
            },
            {
            "category":"1",
            "id":"5",
            "link":"https://www.huffpost.com/entry/carlos-alcaraz-us-open-grand-slam-win_n_631e7452e4b027aa405cf51b",
            "headline":"Carlos Alcaraz Wins U.S. Open For 1st Slam Title, Top Ranking",
            "short_description":"Carlos Alcaraz defeated Casper Ruud in the U.S. Open final to earn his first Grand Slam at age 19 and become the youngest man to move up to No. 1 in the rankings.",
            "authors":"HOWARD FENDRICH, AP",
            "date":"2022-09-11","image":""
            },
            {
            "category":"2",
            "id":"1",
            "link":"https://www.huffpost.com/entry/twitch-streamers-threaten-strike-gambling_n_632a72bce4b0cd3ec2628b20",
            "headline":"Twitch Bans Gambling Sites After Streamer Scams Folks Out Of $200,000",
            "short_description":"One man's claims that he scammed people on the platform caused several popular streamers to consider a Twitch boycott.",
            "authors":"Ben Blanchet",
            "date":"2022-09-21","image":"https://img.huffingtonpost.com/asset/6490e1612300001c00075e30.png?cache=sj4Vcj7j9n&ops=434_244%2Cquality_75&format=webp"
            },
            {
            "category":"2",
            "id":"2",
            "link":"https://www.huffpost.com/entry/bc-us-tiktok-misinformation_n_6321c9b0e4b027aa40614814",
            "headline":"TikTok Search Results Riddled With Misinformation: Report",
            "short_description":"A U.S. firm that monitors false online claims reports that searches for information about prominent news topics on TikTok are likely to turn up results riddled with misinformation.",
            "authors":"DAVID KLEPPER, AP",
            "date":"2022-09-14","image":"https://img.huffingtonpost.com/asset/6321cb762200003200276f64.jpeg?ops=scalefit_720_noupscale&format=webp"
            },
            {
            "category":"2",
            "id":"3",
            "link":"https://www.huffpost.com/entry/ap-us-los-angeles-schools-cyberattack_n_63184088e4b046aa022f1bd4",
            "headline":"Cyberattack Prompts Los Angeles School District To Shut Down Its Computer Systems",
            "short_description":"Such attacks have become a growing threat to U.S. schools, with several high-profile incidents reported since last year.",
            "authors":"Stefanie Dazio, Frank Bajak and Zeke Miller, AP",
            "date":"2022-09-07","image":""
            },
            {
            "category":"2",
            "id":"4",
            "link":"https://www.huffpost.com/entry/cloudflare-kiwi-farms_n_6315993ae4b0eac9f4ce0ba1",
            "headline":"Citing Imminent Danger Cloudflare Drops Hate Site Kiwi Farms",
            "short_description":"Cloudflare CEO Matthew Prince had previously resisted calls to block the site.",
            "authors":"The Associated Press, AP",
            "date":"2022-09-05","image":""
            },
            {
            "category":"2",
            "id":"5",
            "link":"https://www.huffpost.com/entry/fuel-leak-ruins-nasa-launch-moon-artemis_n_63137247e4b0eac9f4cd4aa2",
            "headline":"Fuel Leak Ruins NASA's 2nd Shot At Launching New Moon Rocket",
            "short_description":"Part of the space agency's Artemis program, the rocket is the most powerful to date.",
            "authors":"Marcia Dunn, AP",
            "date":"2022-09-03","image":""
            },
            {
            "category":"3",
            "id":"1",
            "link":"https://www.huffpost.com/entry/how-to-hide-tan-lines_l_62e7edc2e4b09d14dc450969",
            "headline":"How To Hide Even The Worst Tan Lines, According To Makeup Pros",
            "short_description":"Quick solutions to fix your farmer’s tan, from body makeup to self tanner.",
            "authors":"Julie Kendrick",
            "date":"2022-08-08","image":"https://img.huffingtonpost.com/asset/62b216f7210000ae215edfd4.png?ops=scalefit_960_noupscale&format=webp"
            },
            {
            "category":"3",
            "id":"2",
            "link":"https://www.huffpost.com/entry/jello-skin-tiktok_l_62b5bc22e4b04a6173695b03",
            "headline":"Jello Skin: The Latest TikTok Skin Care Trend And How To Achieve It",
            "short_description":"Jell-O is bouncy, jiggly and always snaps back after the slightest movement. According to the latest TikTok trend, your skin should be the same way.",
            "authors":"Rebecca Rovenstine",
            "date":"2022-07-05","image":"https://img.huffingtonpost.com/asset/62b5c64d2100002c445ee54d.png?cache=na5ureTlqc&ops=scalefit_720_noupscale&format=webp"
            },
            {
            "category":"3",
            "id":"3",
            "link":"https://www.huffpost.com/entry/how-to-treat-bug-bites-dermatologists_l_629e5e54e4b090b53b882a74",
            "headline":"How To Treat Bug Bites The Way Dermatologists Do At Home",
            "short_description":"Here's what to order now so you'll be itch-free all summer.",
            "authors":"Julie Kendrick",
            "date":"2022-06-16","image":""
            },
            {
            "category":"3",
            "id":"4",
            "link":"https://www.huffpost.com/entry/how-to-prevent-chafing-men_l_629113eae4b05cfc269a1baa",
            "headline":"How To Prevent And Treat Summer Chafing For Men",
            "short_description":"Ditch the discomfort down there with these dermatologist-recommended tips.",
            "authors":"Katie McPherson",
            "date":"2022-06-07","image":""
            },
            {
            "category":"3",
            "id":"5",
            "link":"https://www.huffpost.com/entry/atypical-mole-dermatologist_l_628671b0e4b0acd09d25dd8d",
            "headline":"If Your Mole Looks Like This, It's Time To See A Dermatologist",
            "short_description":"Experts explain the signs of melanoma to look out for on your skin.",
            "authors":"Kelsey Borresen",
            "date":"2022-05-23","image":""
            },
            {
            "category":"4",
            "id":"1",
            "link":"https://www.huffpost.com/entry/rei-workers-berkeley-store-union_n_6307a5f4e4b0f72c09ded80d",
            "headline":"REI Workers At Berkeley Store Vote To Unionize In Another Win For Labor",
            "short_description":"They follow in the footsteps of REI workers in New York City who formed a union earlier this year.",
            "authors":"Dave Jamieson",
            "date":"2022-08-25","image":"https://img.huffingtonpost.com/asset/6307a6782100003100dc77a8.jpeg?ops=scalefit_720_noupscale&format=webp"
            },
            {
            "category":"4",
            "id":"2",
            "link":"https://www.huffpost.com/entry/twitter-elon-musk-trial-october_n_62d7c115e4b000da23f9c7df",
            "headline":"Twitter Lawyer Calls Elon Musk 'Committed Enemy' As Judge Sets October Trial",
            "short_description":"Delaware Chancery Judge Kathaleen McCormick dealt the world's richest person a setback in ordering a speedy trial on his abandoned deal to buy Twitter.",
            "authors":"Marita Vlachou",
            "date":"2022-07-20","image":"https://img.huffingtonpost.com/asset/62d17e88210000f6635f01e4.jpeg?cache=8nrgoas7ek&ops=210_120&format=webp"
            },
            {
            "category":"4",
            "id":"3",
            "link":"https://www.huffpost.com/entry/starbucks-leaves-russian-market-shuts-stores_n_628b9804e4b05cfc268f4413",
            "headline":"Starbucks Leaving Russian Market, Shutting 130 Stores",
            "short_description":"Starbucks' move follows McDonald's exit from the Russian market last week.",
            "authors":"DEE-ANN DURBIN, AP",
            "date":"2022-05-23","image":""
            },
            {
            "category":"4",
            "id":"4",
            "link":"https://www.huffpost.com/entry/coinbase-crypto-slumping_n_627c5582e4b0b74b0e7ed621",
            "headline":"Crypto Crash Leaves Trading Platform Coinbase Slumped",
            "short_description":"Cryptocurrency trading platform Coinbase has lost half its value in the past week.",
            "authors":"Matt Ott, AP",
            "date":"2022-05-12","image":""
            },
            {
            "category":"4",
            "id":"5",
            "link":"https://www.huffpost.com/entry/us-april-jobs-report-2022_n_627517dfe4b009a811c295ec",
            "headline":"US Added 428,000 Jobs In April Despite Surging Inflation",
            "short_description":"At 3.6%, unemployment nearly reached the lowest level in half a century.",
            "authors":"Paul Wiseman, AP",
            "date":"2022-05-06","image":""
            },
            {
            "category":"5",
            "id":"1",
            "link":"https://www.huffpost.com/entry/funniest-tweets-cats-dogs-september-17-23_n_632de332e4b0695c1d81dc02",
            "headline":"23 Of The Funniest Tweets About Cats And Dogs This Week (Sept. 17-23)",
            "short_description":"\"Until you have a dog you don't understand what could be eaten.\"",
            "authors":"Elyse Wanshel",
            "date":"2022-09-23","image":"https://pbs.twimg.com/media/FdStJ80WQAEHz5y?format=jpg&name=small"
            },
            {
            "category":"5",
            "id":"2",
            "link":"https://www.huffpost.com/entry/golden-globes-return-nbc_n_6329f151e4b0ed991abda7f3",
            "headline":"Golden Globes Returning To NBC In January After Year Off-Air",
            "short_description":"For the past 18 months, Hollywood has effectively boycotted the Globes after reports that the HFPA’s 87 members of non-American journalists included no Black members.",
            "authors":null,
            "date":"2022-09-20","image":"https://img.huffingtonpost.com/asset/6329f25f2200003300ed2388.jpeg?cache=NfVLqOM7zX&ops=scalefit_720_noupscale&format=webp"
            },
            {
            "category":"5",
            "id":"3",
            "link":"https://www.huffpost.com/entry/james-cameron-fought-studio-avatar_n_63268723e4b046aa02400678",
            "headline":"James Cameron Says He 'Clashed' With Studio Before 'Avatar' Release",
            "short_description":"The \"Avatar\" director said aspects of his 2009 movie are \"still competitive with everything that’s out there these days.\"",
            "authors":"Ben Blanchet",
            "date":"2022-09-18","image":""
            },
            {
            "category":"5",
            "id":"4",
            "link":"https://www.huffpost.com/entry/blade-runner-2099-series-announced_n_63247adfe4b027aa40656cc0",
            "headline":"Amazon Greenlights 'Blade Runner 2099' Limited Series Produced By Ridley Scott",
            "short_description":"The director of the original 1982 film joins a writer of the 2017 sequel for the newest installment in the sci-fi franchise.",
            "authors":"Marco Margaritoff",
            "date":"2022-09-16","image":""
            },
            {
            "category":"5",
            "id":"5",
            "link":"https://www.huffpost.com/entry/the-phantom-of-the-opera-to-close-on-broadway-next-year_n_6324ef40e4b082746bea3ce3",
            "headline":"'The Phantom Of The Opera' To Close On Broadway Next Year",
            "short_description":"“The Phantom of the Opera” — Broadway’s longest-running show — is scheduled to close in February 2023, a victim of post-pandemic softening in theater attendance in New York.",
            "authors":"Mark Kennedy, AP",
            "date":"2022-09-16","image":""
            },
            {
            "category":"6",
            "id":"1",
            "link":"https://www.huffpost.com/entry/funniest-parenting-tweets_l_632d7d15e4b0d12b5403e479",
            "headline":"The Funniest Tweets From Parents This Week (Sept. 17-23)",
            "short_description":"\"Accidentally put grown-up toothpaste on my toddler’s toothbrush and he screamed like I was cleaning his teeth with a Carolina Reaper dipped in Tabasco sauce.\"",
            "authors":"Caroline Bologna",
            "date":"2022-09-23","image":"https://img.huffingtonpost.com/asset/630f85cc24000062005e9860.jpeg?ops=scalefit_720_noupscale&format=webp"
            },
            {
            "category":"6",
            "id":"2",
            "link":"https://www.huffpost.com/entry/freeze-drying-breast-milk_l_630e3263e4b065bfc4b25a89",
            "headline":"Should You Freeze-Dry Your Breast Milk?",
            "short_description":"If your freezer is overflowing, or you're tired of carrying around ice packs and bottles of pumped milk, this option could be for you.",
            "authors":"Marie Holmes",
            "date":"2022-09-01","image":"https://img.huffingtonpost.com/asset/630f84bc2000005800d9cc53.jpeg?ops=scalefit_720_noupscale&format=webp"
            },
            {
            "category":"6",
            "id":"3",
            "link":"https://www.huffpost.com/entry/breastfeeding-depression-dysphoric-milk-ejection-reflex_l_6307a405e4b052615d78f20a",
            "headline":"This Breastfeeding Condition Makes Moms Feel Dread, Disgust And Despair",
            "short_description":"Moms with dysphoric milk-ejection reflex (D-MER) feel an intense but brief wave of depression, anxiety or other negative emotion before letdown. And it's more common than you might think.",
            "authors":"Kelsey Borresen",
            "date":"2022-08-30","image":""
            },
            {
            "category":"6",
            "id":"4",
            "link":"https://www.huffpost.com/entry/aap-new-breastfeeding-guidelines-two-years_l_62c5f760e4b06e3d9bb064dd",
            "headline":"The Problem With The AAP's New Breastfeeding Guidelines",
            "short_description":"The American Academy Of Pediatrics is calling for support for breastfeeding for two years or more. Some are applauding the change, but many moms feel defeated and dismayed.",
            "authors":"Kelsey Borresen",
            "date":"2022-07-08","image":""
            },
            {
            "category":"6",
            "id":"5",
            "link":"https://www.huffpost.com/entry/funniest-tweets-from-parents-june-25-july-1_l_62bf4bc1e4b0f6125726e16d",
            "headline":"The Funniest Tweets From Parents This Week (June 25-July 1)",
            "short_description":"\"Spend $250 on your kid playing soccer so they can tell you the only thing they enjoyed is the popsicle at the end of the game.\"",
            "authors":"Brittany Wong",
            "date":"2022-07-01","image":""
            },
            {
            "category":"7",
            "id":"1",
            "link":"https://www.huffpost.com/entry/puerto-rico-water-hurricane-fiona_n_632bdfd8e4b0d12b54014e13",
            "headline":"Puerto Ricans Desperate For Water After Hurricane Fiona’s Rampage",
            "short_description":"More than half a million people remained without water service three days after the storm lashed the U.S. territory.",
            "authors":"DÁNICA COTO, AP",
            "date":"2022-09-22","image":"https://img.huffingtonpost.com/asset/632be17522000035008dc3b0.jpeg?ops=scalefit_720_noupscale&format=webp"
            },
            {
            "category":"7",
            "id":"2",
            "link":"https://www.huffpost.com/entry/biden-un-russian-war-an-affront-to-bodys-charter_n_632ad9e3e4b0bfdf5e1bf5f7",
            "headline":"Biden At UN To Call Russian War An Affront To Body's Charter",
            "short_description":"White House officials say the crux of the president's visit to the U.N. this year will be a full-throated condemnation of Russia and its brutal war.",
            "authors":"Aamer Madhani, AP",
            "date":"2022-09-21","image":"https://img.huffingtonpost.com/asset/632adcba2200005e00503c37.jpeg?cache=UeGKwygtqr&ops=scalefit_720_noupscale&format=webp"
            },
            {
            "category":"7",
            "id":"3",
            "link":"https://www.huffpost.com/entry/bc-soc-wcup-captains-armbands_n_632b1c98e4b0913a3dd7554a",
            "headline":"World Cup Captains Want To Wear Rainbow Armbands In Qatar",
            "short_description":"FIFA has come under pressure from several European soccer federations who want to support a human rights campaign against discrimination at the World Cup.",
            "authors":"GRAHAM DUNBAR, AP",
            "date":"2022-09-21","image":""
            },
            {
            "category":"7",
            "id":"4",
            "link":"https://www.huffpost.com/entry/man-sets-fire-protest-abe-funeral_n_632ae462e4b07198f0146afd",
            "headline":"Man Sets Himself On Fire In Apparent Protest Of Funeral For Japan's Abe",
            "short_description":"The incident underscores a growing wave of protests against the funeral for Shinzo Abe, who was one of the most divisive leaders in postwar Japanese politics.",
            "authors":"Mari Yamaguchi, AP",
            "date":"2022-09-21","image":""
            },
            {
            "category":"7",
            "id":"5",
            "link":"https://www.huffpost.com/entry/fiona-threatens-to-become-category-4-storm-headed-to-bermuda_n_632ad1cae4b07198f0143244",
            "headline":"Fiona Threatens To Become Category 4 Storm Headed To Bermuda",
            "short_description":"Hurricane Fiona lashed the Turks and Caicos Islands and was forecast to squeeze past Bermuda later this week.",
            "authors":"Dánica Coto, AP",
            "date":"2022-09-21","image":""
            },
            {
            "category":"8",
            "id":"1",
            "link":"https://www.huffpost.com/entry/mija-documentary-immigration-isabel-castro-interview_n_632329aee4b000d98858dbda",
            "headline":"How A New Documentary Captures The Complexity Of Being A Child Of Immigrants",
            "short_description":"In \"Mija,\" director Isabel Castro combined music documentaries with the style of \"Euphoria\" and \"Clueless\" to tell a more nuanced immigration story.",
            "authors":"Marina Fang",
            "date":"2022-09-22","image":"https://img.huffingtonpost.com/asset/6323307d2400001e0031bc94.jpeg?cache=GfmeMBBXvc&ops=scalefit_720_noupscale&format=webp"
            },
            {
            "category":"8",
            "id":"2",
            "link":"https://www.huffpost.com/entry/hulu-reboot-should-you-watch-it_n_6324a099e4b0eac9f4e18b46",
            "headline":"'Reboot' Is A Clever And Not Too Navel-Gazey Look Inside TV Reboots",
            "short_description":"Starring Keegan-Michael Key, Judy Greer and Johnny Knoxville, the Hulu show follows the revival of a fictional early 2000s sitcom.",
            "authors":"Marina Fang and Candice Frederick",
            "date":"2022-09-20","image":"https://img.huffingtonpost.com/asset/632875312200001b00f853d4.jpg?cache=FMA2QrXtEc&ops=scalefit_720_noupscale&format=webp"
            },
            {
            "category":"8",
            "id":"3",
            "link":"https://www.huffpost.com/entry/oil-gas-coal-reserves-database_n_6327a81ae4b0eac9f4e2fd23",
            "headline":"First Public Global Database Of Fossil Fuels Launches",
            "short_description":"On Monday, the world’s first public database of fossil fuel production, reserves and emissions launches.",
            "authors":"Drew Costley, AP",
            "date":"2022-09-18","image":""
            },
            {
            "category":"8",
            "id":"4",
            "link":"https://www.huffpost.com/entry/bc-us-alaska-coastal-storm_n_6325f39fe4b0eac9f4e25cbc",
            "headline":"Alaska Prepares For 'Historic-Level' Storm Barreling Towards Coast",
            "short_description":"“In 10 years, people will be referring to the September 2022 storm as a benchmark storm.”",
            "authors":"BECKY BOHRER, MARK THIESSEN and JOHN ANTCZAK, AP",
            "date":"2022-09-17","image":""
            },
            {
            "category":"8",
            "id":"5",
            "link":"https://www.huffpost.com/entry/tropical-storm-fiona-puerto-rico_n_6325d372e4b0ed021dfd719c",
            "headline":"Puerto Rico Braces For Landslides And Severe Flooding As Tropical Storm Fiona Approaches",
            "short_description":"Puerto Rico was under a hurricane watch Saturday as the storm barreled towards the U.S. territory.",
            "authors":"DÁNICA COTO, AP",
            "date":"2022-09-17","image":""
            }
        ]
